import React, { createRef } from 'react';
import moment from 'moment';
import CONSTANT from './../../constant';

import Header from '../../component/common/Header';
import Paging from '../../component/common/Paging';
import FileSearchBar from './../../component/file/FileSearchBar';
import { Typeahead } from 'react-bootstrap-typeahead';

import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';


import { getDateParts, getCookie } from '../../utils';
import { getClosedFileGlobalList, getClosedFileList } from './../../actions/FileAction';
import { Shimmer } from '@fluentui/react';



class ComponentName extends React.Component<any, any> {
    private searchTimeout: any = null; // ADDED: For search debouncing

    constructor(props: any) {
        super(props);
        const userDetail = getCookie(CONSTANT.cookie.userDetail);
        this.state = {
            page: 1,
            limit: "20",
            searchBy: "subject",
            total: 0,
            parkedBy: 'me',
            pending: undefined,
            list: undefined,
            listData: undefined,
            userDetail,
            userOptions: undefined,
            paginationToggle: true,
            ref:createRef(),
            searchTerm: '', // ADDED: Search term state
            isLoading: false, // ADDED: Loading state for search
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.allFiles;
        this.loadList();
        // this.loadGlobalList();
    }

    // ADDED: Cleanup timeout on unmount
    componentWillUnmount() {
        // Clear timeout when component unmounts
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
    }

    // ADDED: Search handler with debouncing
    handleSearch = (searchTerm: string) => {
        this.setState({ searchTerm });

        // Clear existing timeout
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        // Set new timeout for debouncing (wait 500ms after user stops typing)
        this.searchTimeout = setTimeout(() => {
            this.setState({ page: 1, isLoading: true }, () => {
                this.loadList();
            });
        }, 500);
    };


    render() {
        const { page, limit, userOptions, list, userDetail, total, parkedBy, searchTerm } = this.state; // ADDED: searchTerm to destructuring
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className='card homedob p-4 mb-4'>
                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <h3 className="page-title mb-3">Parked File(s)</h3>
                                </div>

                                {/* <div className="col-md-12">
                                    {userOptions === undefined &&
                                        <div className="skeleton mb-3">
                                            <div className="skeleton-wrapper">
                                                <div className="skeleton-wrapper-inner">
                                                    <div className="skeleton-wrapper-body">
                                                        <div className="skeleton-avatar" />
                                                        <div className="skeleton-author" />
                                                        <div className="skeleton-label" />
                                                        <div className="skeleton-content-1" />
                                                        <div className="skeleton-content-2" />
                                                        <div className="skeleton-content-3" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                </div> */}
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-4">
                                    <div className="list-container">
                                        <div className='table-container'>
                                            <div className='table-wrapper'>
                                                <table className="tablen">
                                                    <thead>
                                                        <tr>
                                                            <th colSpan={6} className='p-0'>
                                                                {/* {userOptions !== undefined && */}
                                                                {true &&
                                                                    <div className='p-0'>
                                                                        {/* <div className='parked-file-search-bg px-2'> */}
                                                                        <div className=''>
                                                                            <div className="row m-0 py-3">
                                                                                {/* ADDED: Search Bar */}
                                                                                <div className="col-md-6">
                                                                                    <FileSearchBar 
                                                                                        onSearch={this.handleSearch}
                                                                                        searchValue={searchTerm}
                                                                                    />
                                                                                </div>
                                                                                {/* <div className="col-6 pl-2">
                                                                                    <label>&nbsp;</label>
                                                                                     <Typeahead
                                                                                        className="mb-3"
                                                                                        ref={this.state.ref}
                                                                                        id="public-methods-example"
                                                                                        labelKey={this.state.searchBy}
                                                                                        multiple
                                                                                        options={this.state.userOptions}
                                                                                        placeholder={`Search ${this.state.searchBy === 'closedByName' ? 'closed by name' : this.state.searchBy === 'createdByName'? 'created by name': ' by ' + this.state.searchBy }`}
                                                                                        onChange={(array: any) => {
                                                                                            if (Array.isArray(array) && array.length == 0) {
                                                                                                this.setState({ ...this.state, list: this.state.listData, paginationToggle: true })
                                                                                            } else {
                                                                                                this.setState({ ...this.state, list: array, paginationToggle: false })
                                                                                            }
                                                                                        }
                                                                                        }
                                                                                    /> 
                                                                                </div>
                                                                                <div className="col-2">
                                                                                    <label>Search options</label>
                                                                                    <select className="form-select form-control p-2 px-4" value={this.state.searchBy} onChange={(e: any) => this.searchBy(e.target.value)}>
                                                                                        <option value="subject">Subject</option>
                                                                                        <option value="fileNumber">File Number</option>
                                                                                        <option value="closedByName">Closed By</option>
                                                                                        <option value="createdByName">Created By</option>
                                                                                    </select>
                                                                                     </div>
                                                                                </div> */}
                                                                                <div className='col-1'><label>Select&nbsp;range: </label></div>
                                                                                <div className="col-2">
                                                                                    <select className="form-select form-control p-2 px-4" value={limit} onChange={(e: any) => this.handleLimitChange(e.target.value)}>
                                                                                        <option value="10">10</option>
                                                                                        <option value="20">20</option>
                                                                                        <option value="30">30</option>
                                                                                        <option value="40">40</option>
                                                                                        <option value="50">50</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div className='col-1'><label>Parked by: </label></div>
                                                                                <div className="col-2">
                                                                                    <select className="form-select form-control p-2 px-4" value={parkedBy} onChange={(e: any) => this.handleParkedBy(e.target.value)}>
                                                                                        <option value="me">Me</option>
                                                                                        <option value="others">Others</option>
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th scope="col">Comp. No.</th>
                                                            {/* <th scope="col">Pending with</th> */}
                                                            <th scope="col">Subject</th>
                                                            <th scope="col" className='text-nowrap'>File Number</th>
                                                            <th scope="col" className='text-nowrap'>Financial Implication</th>
                                                            {/* <th scope="col">Created on</th> */}
                                                            <th scope="col" className='text-nowrap'>Created By</th>
                                                            <th scope="col" className='text-nowrap'>Parked By</th>
                                                            {/* <th scope="col">Closed in (Days)</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* MODIFIED: Added loading state check */}
                                                        {
                                                            (list === undefined || this.state.isLoading) && <tr>
                                                                <td colSpan={7} className="text-center">
                                                                    <div className="d-flex justify-content-center align-items-center py-3">
                                                                        <div className="spinner-border text-primary" role="status">
                                                                            <span className="sr-only">Loading...</span>
                                                                        </div>
                                                                        <span className="ml-2">Loading...</span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        }
                                                        {/* MODIFIED: Added loading state check and search-specific message */}
                                                        {
                                                            list !== undefined && !this.state.isLoading && list.length === 0 && <tr>
                                                                <td colSpan={7} className="text-center">
                                                                    {searchTerm 
                                                                        ? "No files match your search" 
                                                                        : "No records found"}
                                                                </td>
                                                            </tr>
                                                        }
                                                        {/* MODIFIED: Added loading state check */}
                                                        {
                                                            list !== undefined && !this.state.isLoading && list.map((item: any, index: number) => {
                                                                const detailPageURL = CONSTANT.component.userFileDetail.url.replace(':code', item.code);
                                                                const dated = getDateParts(item.dated);
                                                                const mo = getDateParts(item.modifiedOn);
                                                                const co = getDateParts(item.closedOn);
                                                                const subjectStr = item.subject.length > 50 ? item.subject.substr(0, 50) + '...' : item.subject;
                                                                const openDateStr = moment(`${dated.year}-${dated.month}-${dated.date}`);
                                                                const closedDateStr = moment(`${co.year}-${co.month}-${co.date}`);

                                                                const diff = Math.abs(Math.floor(moment.duration(closedDateStr.diff(openDateStr)).asDays())) + 1;
                                                                return (
                                                                    <tr key={index} className="c-pointer" onClick={() => this.openDetailPage(detailPageURL)}>
                                                                        <td className="sno">{item?.code}</td>
                                                                        {/* {
                                                                            (userDetail.isHOD || userDetail.code === item.createdBy) ? <td>
                                                                                {
                                                                                    isClosed ? 'File is closed' : `${item.pendingWithName}`
                                                                                }
                                                                            </td> : <td>-</td>
                                                                        } */}
                                                                        <td>{subjectStr}</td>
                                                                        <td>{item.fileNumber}</td>
                                                                        <td>{item.financialImplication ? `${CONSTANT.static.currencySymbol} ${parseFloat(item.financialImplication).toLocaleString(CONSTANT.static.locale)}` : '-'}</td>
                                                                        {/* <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td> */}
                                                                        <td>{item.createdByName} <br /> ( {`${dated.date} ${dated.monthName} ${dated.year}`} )</td>
                                                                        <td> {item.closedByName} <br /> ( {`${co.date} ${co.monthName} ${co.year}`} )</td>
                                                                        {/* <td><b>{diff === 0 ? 'Closed Today' : diff}</b></td> */}
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                        <tr>
                                                            <td colSpan={6} className='p-4'>
                                                                {this.state.paginationToggle &&
                                                                        <div className='col-md-6 offset-3'>
                                                                            {list !== undefined && list.lenght !== 0 && (
                                                                                <ResponsivePagination
                                                                                    activeItemClassName='Pagi-number-ac'
                                                                                    current={page}
                                                                                    total={Math.ceil(total / limit)}
                                                                                    onPageChange={this.handlePageChange}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    }
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                list !== undefined && <Paging page={page} listItem={list} onPageChange={this.changePage} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    // MODIFIED: Added searchTerm parameter and loading state
    loadList = () => {
        const { page, limit, parkedBy, searchTerm } = this.state;
        this.setState({ isLoading: true }); // ADDED: Set loading state
        
        getClosedFileList(page, limit, parkedBy, searchTerm).then((res: any) => {
            if (res) {
                const totalRecords = res?.result?.[0]?.['totalrecords'] || 0;
                this.setState({ 
                    list: res.result, 
                    total: totalRecords, 
                    listData: res.result,
                    isLoading: false // ADDED: Clear loading state
                });
            }
        }).catch(() => {
            this.setState({ isLoading: false }); // ADDED: Clear loading state on error
        });
    }

    loadGlobalList = () => {
        getClosedFileGlobalList().then((res: any) => {
            if (res)
                this.setState({ userOptions: res.result });
        });
    }

    handlePageChange = (newPage: number) => {
        this.setState({ page: newPage, paginationToggle: true }, () => {
            this.loadList(); // Call loadList with the updated page
        });
    }

    handleLimitChange = (newLimit: number) => {
        this.state.ref.current?.clear();
        this.setState({ limit: newLimit, page: 1, paginationToggle: true }, () => {
            this.loadList(); // Call loadList with the updated limit
        });
    }

    handleParkedBy = (newValue: number) => {
        this.state.ref.current?.clear();
        this.setState({ parkedBy: newValue, limit: "10", paginationToggle: true }, () => {
            this.loadList(); // Call loadList with the updated limit
        });
    }

    searchBy = (newValue: String) => {
        this.setState({ searchBy: newValue });
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }

    changePage = (e: any) => {
        const type = e.target.dataset.type;
        const page = type === '+' ? this.state.page + 1 : this.state.page - 1;
        this.setState({ page, list: undefined }, () => {
            this.loadList()
        });
    }
}

export default ComponentName;